import {
  init_boundingBoxRendererUboDeclaration
} from "./chunk-BGBBIVFO.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/boundingBoxRendererVertexDeclaration.js
var name, shader;
var init_boundingBoxRendererVertexDeclaration = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/boundingBoxRendererVertexDeclaration.js"() {
    "use strict";
    init_shaderStore();
    name = "boundingBoxRendererVertexDeclaration";
    shader = `uniform mat4 world;uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

// node_modules/@babylonjs/core/Shaders/boundingBoxRenderer.vertex.js
var name2, shader2, boundingBoxRendererVertexShader;
var init_boundingBoxRenderer_vertex = __esm({
  "node_modules/@babylonjs/core/Shaders/boundingBoxRenderer.vertex.js"() {
    init_shaderStore();
    init_boundingBoxRendererVertexDeclaration();
    init_boundingBoxRendererUboDeclaration();
    name2 = "boundingBoxRendererVertexShader";
    shader2 = `attribute vec3 position;
#include<__decl__boundingBoxRendererVertex>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec4 worldPos=world*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
    ShaderStore.ShadersStore[name2] = shader2;
    boundingBoxRendererVertexShader = { name: name2, shader: shader2 };
  }
});

export {
  boundingBoxRendererVertexShader,
  init_boundingBoxRenderer_vertex
};
